import script from "./VWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./VWidget.vue?vue&type=script&setup=true&lang=ts"

import "./VWidget.vue?vue&type=style&index=0&id=19215d8e&lang=scss"

const __exports__ = script;

export default __exports__